import React from 'react';
import PropTypes from 'prop-types';

import ResultsCount from 'components/ResultsCount';

export const PaginatedResultsCount = ({
  resultsCount,
  resultsOffset,
  resultsTotal,
  ...restProps
}) => {
  const resultsCountFrom = resultsTotal > 0 ? resultsOffset + 1 : 0;
  const resultsCountTo = resultsOffset + resultsCount;

  return (
    <ResultsCount
      {...restProps}
      resultsCountFrom={resultsCountFrom}
      resultsCountTo={resultsCountTo}
      resultsTotal={resultsTotal || 0}
    />
  );
};

PaginatedResultsCount.propTypes = {
  resultsCount: PropTypes.number.isRequired,
  resultsOffset: PropTypes.number.isRequired,
  resultsTotal: PropTypes.number.isRequired,
};

export default PaginatedResultsCount;
